import { XeroAccount } from './xero-account.model';

export const RESOLVE_KEY = 'xeroData';
export const ACCOUNT_STATUS_ROUTE = 'account_status';
export const CALLBACK_URL = 'callback_url';
export const AUTH_URL_ROUTE = 'auth_url';
export const EXPORT_DOCUMENT = 'export_document';
export const XERO_SETUP_MSG_TOKEN = 'xero_setup_msg_token';
export const XERO_SUCCESS_MSG_PARAM = 'success';
export const XERO_ERROR_MSG_PARAM = 'error';
export const XERO_PROMO_LOGO_SRC = 'assets/icons/xero-logo.png';
export const XERO_EXTERNAL_LINK =
  'https://support.2go.com/hc/articles/360007751231';

export interface IXeroAccountDataResolveData {
  xeroAccount: XeroAccount;
}

export enum XeroAccountStatusEnum {
  UNAUTHORIZED = 'UNAUTHORIZED',
  AUTHORIZED = 'AUTHORIZED',
  INTEGRATED = 'INTEGRATED',
}
